<template>
  <div
    class="sog-checkbox"
    :style="_style"
  >
    <CheckBoxComponent
      :checked="_value"
      :label="placeholder"
      :disabled="disabled"
      @change="onChange"
    />
  </div>
</template>

<script setup lang="ts">
import { CheckBoxComponent } from "@syncfusion/ej2-vue-buttons";
import { computed, ref, watch } from "vue";

interface Props {
  modelValue?: boolean;
  placeholder?: string;
  disabled?: boolean;
  width?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  placeholder: undefined,
  disabled: false,
  width: undefined,
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = defineEmits(["update:modelValue"]);

const _value = ref(false);

watch(
  props,
  () => {
    _value.value = props.modelValue ?? false;
  },
  { immediate: true }
);

const _style = computed<string>(() => (props.width ? "width: " + props.width : ""));

function onChange(args: { checked: boolean }) {
  _value.value = args.checked;
  emit("update:modelValue", _value.value);
}
</script>

<style scoped>
.sog-checkbox :deep(.e-checkbox-wrapper) {
  display: flex;
  align-items: flex-start;
}

.sog-checkbox :deep(.e-frame) {
  flex-shrink: 0;
}

.sog-checkbox :deep(.e-label) {
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}
</style>
